import React, { useEffect, useState } from 'react';
import './HeaderComponent.css';
import Logo from './LogoComponent';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { clearAccessToken } from "../../services/userAuthSlice";
import api from "../../services/api";
function HeaderComponent() {
    const [scrolled, setScrolled] = useState(false);
    // const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione
    const dispatch = useDispatch();
    const token = useSelector((state) => state.userAuth.token);
    const userId = useSelector((state) => state.userAuth.userId);
    // console.log("HeaderComponent – Redux:", token, userId);

    const isLoggedIn = Boolean(token && userId);

    // useEffect(() => {
    //     const token = localStorage.getItem('token');
    //     setIsLoggedIn(!!token);
    // }, []);

    useEffect(() => {

        const handleScroll = () => {
            setScrolled(window.scrollY > 0);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const goToSection = (id) => {
        navigate('/#'+id)
    };

    const handleLogin = () => {
        navigate('/login')
    };

    const handleSignUp = () => {
        navigate('/registration')
    };

    const handleLogout = () => {

        dispatch(clearAccessToken());
        dispatch(api.util.invalidateTags(['User']));
        navigate('/')
    };
    // console.log("HeaderComponent – Redux:", token, userId);

    return (
        <header className={`header-main sticky-top ${scrolled ? 'header-shrink shadow-sm' : ''}`}>
            <nav className={`navbar navbar-expand-lg navbar-dark bg-dark  header-main ${scrolled ? 'header-shrink shadow-sm' : ''}`}>
                <div className="container-fluid">
                    <a className="navbar-brand d-flex align-items-center" href="/">
                        <Logo />
                    </a>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse p-3" id="navbarNav">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="/">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" onClick={() => {goToSection('prezzi')} }>Prezzi</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link " onClick={() => {goToSection('chisiamo')}} >Chi non siamo</a>
                            </li>
                        </ul>

                        {!isLoggedIn ? (
                            <div className="d-flex">
                                <button className="btn btn-outline-primary me-2" onClick={handleLogin}>Login</button>
                                <button className="btn btn-primary" onClick={handleSignUp}>Sign-up</button>
                            </div>
                        ) : (
                            <div className="dropdown text-end">
                                <a href="#"
                                   className="d-block text-decoration-none dropdown-toggle"
                                   id="dropdownMenuLink"
                                   role="button"
                                   data-bs-toggle="dropdown"
                                   aria-expanded="false">
                                    {/*<img src="https://github.com/mdo.png" alt="mdo" width="32" height="32" className="rounded-circle" />*/}
                                    <img src="/user.png" alt="mdo" width="32" height="32" className="rounded-circle" />
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end text-small" aria-labelledby="dropdownMenuLink">
                                    <li><a className="dropdown-item" href="/profile">Profile</a></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default HeaderComponent;
